import { createSlice } from '@reduxjs/toolkit';

interface InitialStateProps {
  request: {
    isLoading: boolean;
    error: string | null;
  };
  list: {
    isLoading: boolean;
    hits: any[] | null;
    total: number | null;
    error: string | null;
  };
  one: {
    isLoading: boolean;
    data: Record<string, any> | null;
    error: string | null;
  };
  warehouse: {
    isLoading: boolean;
    hits: any[] | null;
    total: number | null;
    error: string | null;
  };
}

const initialState: InitialStateProps = {
  request: {
    isLoading: false,
    error: null,
  },
  list: {
    isLoading: false,
    hits: null,
    total: null,
    error: null,
  },
  one: {
    isLoading: false,
    data: null,
    error: null,
  },
  warehouse: {
    isLoading: false,
    hits: null,
    total: null,
    error: null,
  },
};

export const { actions: directionActions, reducer: directionReducer } = createSlice({
  name: 'direction',
  initialState,
  reducers: {
    //Request
    setDirectionRequestStart: (state) => {
      state.request = {
        isLoading: true,
        error: null,
      };
    },
    setDirectionRequestSuccess: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    setDirectionRequestFailure: (state, { payload }) => {
      state.request = {
        isLoading: false,
        error: payload.message,
      };
    },
    setDirectionRequestDefault: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    //List
    setDirectionListRequest: (state) => {
      state.list = {
        isLoading: true,
        hits: null,
        total: null,
        error: null,
      };
    },
    setDirectionListSuccess: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: payload.hits,
        total: payload.total,
        error: null,
      };
    },
    setDirectionListFailure: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: payload.message,
      };
    },
    setDirectionListDefault: (state) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: null,
      };
    },
    //One
    setDirectionOneRequest: (state) => {
      state.one = {
        isLoading: true,
        data: null,
        error: null,
      };
    },
    setDirectionOneSuccess: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: payload,
        error: null,
      };
    },
    setDirectionOneFailure: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: null,
        error: payload.message,
      };
    },
    setDirectionOneDefault: (state) => {
      state.one = {
        isLoading: false,
        data: null,
        error: null,
      };
    },
    //Warehouse
    setDirectionWarehouseRequest: (state) => {
      state.warehouse = {
        isLoading: true,
        hits: null,
        total: null,
        error: null,
      };
    },
    setDirectionWarehouseSuccess: (state, { payload }) => {
      state.warehouse = {
        isLoading: false,
        hits: payload.hits,
        total: payload.total,
        error: null,
      };
    },
    setDirectionWarehouseFailure: (state, { payload }) => {
      state.warehouse = {
        isLoading: false,
        hits: null,
        total: null,
        error: payload.message,
      };
    },
    setDirectionWarehouseDefault: (state) => {
      state.warehouse = {
        isLoading: false,
        hits: null,
        total: null,
        error: null,
      };
    },
  },
});
